import { useAppKitAccount } from '@reown/appkit/react';

import { Currency } from '@/constants';

import useReownNamespaceByCurrency from './useReownNamespaceByCurrency';

function useReownAccountByCurrency(currency: Currency) {
  const namespace = useReownNamespaceByCurrency(currency);

  return useAppKitAccount({ namespace });
}

export default useReownAccountByCurrency;
